import { lookAndFeelEntryPoint } from '@jira/admin-pages__system-look-and-feel/src/lookAndFeelEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { lookAndFeelRoute } from '@jira/router-routes__look-and-feel-routes/src/lookAndFeelRoute.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router/src/common/types';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';

const lookAndFeelPageEntryPoint = createPageEntryPoint({
	main: lookAndFeelEntryPoint,
});

export const lookAndFeelRouteEntry: Route = createEntry(lookAndFeelRoute, () => ({
	group: 'global-settings',
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		conditionalPostOfficeJiraTopBannerResource,
	],

	entryPoint: () => {
		return lookAndFeelPageEntryPoint;
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
